import { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { LocalizedText, useFeatureFlag } from '@mews/framework';
import { TextKey, DataTestId, FeatureFlag } from '@mews-commander/enums';
import { IconName, getDisableClickAwayProps } from '@optimus-web/core';
import { ApplicationState } from '@mews-commander/types';
import { isCurrentProfilePlatformAdmin } from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { isSalesForceInitialized, isSalesForceLoaded, initSalesForce } from '@mews-commander/chat';
import { isFunctionalConsentGiven } from '../../trackingConsent/selectors';
import { NavbarIconButton } from '../../../components';
import { useOpenTicketByUrlParam } from '../hooks';
import { SeparatorElement } from './styles';
import ChatButton from './ChatButton';
import AllowChatButton from './AllowChatButton';
import { AdaChatBotButton } from './AdaChatBotButton';

interface HelpMenuProps {
    isSalesForceChatInitialized: boolean;
    isChatConsentGiven: boolean;
    isPlatformAdmin: boolean;
    isSalesForceChatLoaded: boolean;
}

interface HelpMenuDispatchProps {
    initSalesForceChat(): void;
}

const HelpMenu = ({
    isSalesForceChatInitialized,
    isChatConsentGiven,
    isPlatformAdmin,
    isSalesForceChatLoaded,
    initSalesForceChat,
}: HelpMenuProps & HelpMenuDispatchProps) => {
    const isAdaEmbeddedFeatureFlagEnabled = useFeatureFlag(FeatureFlag.adaEmbeddedFeatureFlagEnabled);
    const isSalesForceChatReadyToInit = !isSalesForceChatInitialized && isSalesForceChatLoaded && isChatConsentGiven;
    const isAdaChatBotV2Enabled = useFeatureFlag(FeatureFlag.adaChatBotV2Enabled);

    useOpenTicketByUrlParam();

    useEffect(() => {
        if (isSalesForceChatReadyToInit && !isAdaEmbeddedFeatureFlagEnabled) {
            initSalesForceChat();
        }
    }, [initSalesForceChat, isAdaEmbeddedFeatureFlagEnabled, isSalesForceChatReadyToInit]);

    return (
        <>
            <SeparatorElement />
            {isAdaChatBotV2Enabled && <AdaChatBotButton />}
            {!isAdaEmbeddedFeatureFlagEnabled && (
                <>
                    {isSalesForceChatInitialized && isChatConsentGiven ? (
                        <ChatButton data-test-id={DataTestId.NavbarChatButton} />
                    ) : (
                        <AllowChatButton data-test-id={DataTestId.NavbarChatButton} />
                    )}
                </>
            )}
            {!isPlatformAdmin ? (
                <NavbarIconButton
                    // @ts-expect-error $TSFixMeError: No overload matches this call.
                    id="beamerElement"
                    icon={IconName.Megaphone}
                    title={<LocalizedText textKey={TextKey.ReleaseNotePlural} />}
                    {...getDisableClickAwayProps()}
                />
            ) : null}
        </>
    );
};

export default connect<HelpMenuProps, HelpMenuDispatchProps, {}, ApplicationState>(
    createStructuredSelector<ApplicationState, {}, HelpMenuProps>({
        isSalesForceChatInitialized: isSalesForceInitialized,
        isChatConsentGiven: isFunctionalConsentGiven,
        isPlatformAdmin: isCurrentProfilePlatformAdmin,
        isSalesForceChatLoaded: isSalesForceLoaded,
    }),
    {
        initSalesForceChat: initSalesForce,
    }
)(HelpMenu);
